module.exports = __webpack_public_path__ + "img/95fea36.png";